import { render, staticRenderFns } from "./PermissionsGroupCardCreate.vue?vue&type=template&id=79cbc7d4"
import script from "./PermissionsGroupCardCreate.vue?vue&type=script&lang=js"
export * from "./PermissionsGroupCardCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports